const createSellerForBackend = (seller) => ({
	channelId: seller.channelId,
	regionId: seller.regionId,
	agencyId: seller.agencyId,
	manager: {
		login: seller.manager,
	},
	seller: seller.login
		? {
				login: seller.login,
		  }
		: undefined,
});

export const requestFactory = (nominatedSeller) => {
	return {
		nominatedSeller: createSellerForBackend(nominatedSeller),
	};
};
